export default __webpack_public_path__ + "9877f97487afc9c1175cd64158cebcdd.svg";